@if (isLoading()) {
  <app-loader/>
}
<mat-tab-group (selectedTabChange)="handleTabChange($event)">
  <mat-tab label="Добавить нового">
    <form
      [formGroup]="productCardFormGroup"
      class="product-card-form"
    >
      @for (field of newProductCardFormFields; track $index) {
        @if(field.isVisible) {
          <mat-form-field
            appearance="outline"
            [class.none-pointer-events]="field.isReadonly"
          >
            <mat-label>{{ field.label }}</mat-label>
            <input
              matInput
              type="text"
              [formControlName]="field.fieldName"
            >
          </mat-form-field>
        }
      }
    </form>
  </mat-tab>
  <mat-tab
    [label]="getCurrentProductTabLabel()"
    [disabled]="!hasProductCards"
  >
    <div class="product-card-form">
      <mat-form-field
        class="product-card-search"
        appearance="outline"
      >
        <input
          matInput
          placeholder="Поиск по названию и артикулу"
          [(ngModel)]="searchValue"
          (change)="fetchProductCardsData()"
        >
        <mat-label>Поиск по названию и артикулу</mat-label>
      </mat-form-field>
      <div class="product-card-list">
        <mat-selection-list
          [multiple]="false"
          [(ngModel)]="selectedProductCards"
        >
          @for (productCard of productCards; track $index) {
            <mat-list-option [value]="productCard">
              <div class="product-card-info">
                <div class="product-card-info-header">
                  <div class="product-card-info-article">Артикул: {{ productCard.article }}</div>
                  <div class="product-card-info-id">Id: {{ productCard.id }}</div>
                </div>
                <div class="product-card-info-name">Продукт: {{ productCard.title }}</div>
              </div>
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>
<div class="buttons-container">
  <button
    mat-button
    color="primary"
    [disabled]="getDisabledBtn()"
    (click)="handleAttach()"
  >
    {{ getBtnLabel() }}
  </button>
  <button
    mat-button
    tabindex="-1"
    color="warn"
    (click)="handleCloseDialog.emit('cancel')"
  >
    Закрыть
  </button>
</div>
